// 签到领现金相关路由
export default {
  routes: [
    // 签到领现金首页
    {
      path: '/(\\s*)dailycheckin(\\d*)/(\\s*)index(\\d*)',
      name: 'dailycheckinIndex',
      meta: {
        desc: '签到领现金'
      },
      component: () =>
        import(/* webpackChunkName: "dailycheckinIndex" */ '../views/dailycheckin/index/index.vue')
    },
    // 签到领现金提现页
    {
      path: '/(\\s*)dailycheckin(\\d*)/(\\s*)withdraw(\\d*)',
      name: 'dailycheckinWithdraw',
      meta: {
        desc: '签到领现金提现页'
      },
      component: () =>
        import(
          /* webpackChunkName: "dailycheckinWithdraw" */ '../views/dailycheckin/widthdraw/index.vue'
        )
    }
  ]
}
